import { $t } from '@/utils/languageAuto';
import { __decorate, __extends } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import Breadcrumb from '@/components/breadcrumb/index.vue';
import addOrEdit from '@/views/order/returnOrder/fbaRemovalOrder/addOrEdit/index.vue';

var CopyFbaRemovalOrderPage = function (_super) {
  __extends(CopyFbaRemovalOrderPage, _super);

  function CopyFbaRemovalOrderPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.breadcrumbData = [];
    return _this;
  }

  CopyFbaRemovalOrderPage.prototype.created = function () {
    this.breadcrumbData = [{
      routerName: 'ReturnOrderPage',
      title: this.t('退货管理'),
      query: {
        order_type: this.$enum.order.ReturnOrderType.FbaRemovalOrder
      }
    }, {
      title: this.t('复制FBA移除退仓单')
    }];
  };

  CopyFbaRemovalOrderPage = __decorate([Component({
    components: {
      Breadcrumb: Breadcrumb,
      addOrEdit: addOrEdit
    }
  })], CopyFbaRemovalOrderPage);
  return CopyFbaRemovalOrderPage;
}(Vue);

export default CopyFbaRemovalOrderPage;